'use client';

import { useTranslations } from 'next-intl';
import { useGetEmployeesQuery } from '@api/api';
import MailButton from '@components/MailButton';
import PhoneButton from '@components/PhoneButton';
import Accordion from '@components/Accordion';
import { FaPhone } from 'react-icons/fa6';
import { BsFillEnvelopeFill } from 'react-icons/bs';
import { PiUserCircleFill } from 'react-icons/pi';

export default function ContactSellerFixedPrice() {
  const t = useTranslations('ContactSeller');
  const { data, isFetching } = useGetEmployeesQuery();

  return (
    <div className='flex flex-col gap-2 p-6'>
      <PhoneButton />
      <MailButton />
      <Accordion title={<div className='flex items-center gap-1'><PiUserCircleFill /> {t('buttonText')}</div>} theme='black'>
        {!isFetching && !!data?.data?.length && (
          <div className='grid grid-cols-1 gap-4'>
            {data.data.map((employee: any) => {
              if (!employee.email && !employee.cellphone) {
                return null;
              }
              if (!employee.seller) {
                return null;
              }
              return (
                <div
                  key={employee.id}
                  className='flex w-full grow flex-col'
                >
                  <h3 className='text-md font-semibold'>{employee.name}</h3>
                  <div className='flex flex-col'>
                    {employee.email && <a href={`mailto:${employee.email}`} className='flex items-center gap-1'><BsFillEnvelopeFill /> {employee.email}</a>}
                    {employee.cellphone && <a href={`tel:${employee.cellphone}`} className='flex items-center gap-1'><FaPhone /> {employee.cellphone}</a>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Accordion>
    </div>
  );
}
